<template>
  <div class="introduction-box">
    <transition name="introduction-demo">
      <div class="introduction-demo-area" v-show="isaActivated">
        <div class="introduction-title">NANAフリマ</div>
        <div class="introduction-title2">
          「NANAフリマ」とは、中国にいながら、日本語で、<br>
          個人間のモノの売り買いを楽しめるフリマ機能です！
        </div>
        <div class="introduction-title3">NANAフリマの特長</div>
        <ul style="list-style-type: disc;">
          <li
            class="introduction-list"
            v-for="(n, index) in introductionList"
            :key="index"
            v-html="n"
          ></li>
        </ul>
      </div>
    </transition>
    <div class="introduction-image">
      <img :src="partsImage" v-show="isaActivated" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      introductionList: [
        "全て日本語による操作が可能です。",
        "多くの決済方法（日本のクレジットカード含む）が選択可能です。",
        "配送方法（配送or直接受け渡し）を選択することが可能です。",
        "第三者エクスロー支払方式を活用することにより双方にリスクの少ないお取引が可能です。",
        " 中国人ユーザーの方への販売が期待できます。",
      ],
      shadow: "box-shadow:0px 0px 108px 0px rgba(238,178,94,0.18);",
      partsImage: null,
      isaActivated: false,
    };
  },
  methods: {
    init(partsImage) {
      this.isaActivated = true;
      this.partsImage = partsImage;
      return this.shadow;
    },
    back() {
      this.isaActivated = false;
    },
  },
};
</script>
<style scoped>
.introduction-box {
  width: 100%;
  height: 100%;
  justify-content: space-around;
  display: flex;
  background-color: white;

}
.introduction-demo{

}
.introduction-demo-area {
  /* width: 800px; */
  width: 6.8rem;
  padding-top: 1rem;
  overflow: hidden;
  height: 100%;
  padding-left: 0.5rem;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.introduction-demo-area .introduction-title {
  font-size: 0.6rem;
  font-weight: bold;
  text-indent: -0.1rem;
  color: #50391e;
}
.introduction-demo-area .introduction-title2 {
  padding-top: 0.2rem;
  font-size: 0.2rem;
  font-weight: bold;
  color: #50391e;
  padding-left: -0.1rem;
}
.introduction-demo-area .introduction-title3{
  padding-top: 0.2rem;
  font-size: 0.20rem;
  font-weight: bold;
  text-indent: -0.1rem;
  color: #50391e;
}

.introduction-list {
  line-height: 0.35rem;
  font-size: 0.18rem;
  
  
  color: #50391e;
 
}
.introduction-image{
  width: 5rem;
}
.introduction-image img {
  
  width: 100%;
  height: auto;
  padding-top: 1rem;
}
.introduction-demo-enter-active,
.introduction-demo-leave-active {
  transition: all 0.5s;
}
.introduction-demo-enter, .introduction-demo-leave-to /* .fade-leave-active below version 2.1.8 */ {
  right: -6.5rem;
}
.food-bottom-icons {
  display: block;
  margin: 0 auto;
  width: 5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/round-spare-parts/flea_market.vue